import axios from "axios";

export const BASE_URL = `${process.env.REACT_APP_API_BASE}/LOGINREGISTRATION/api/v1`;
export const ENROLLMENT_URL = `${process.env.REACT_APP_API_BASE}/ENROLLMENTSERVICE/enrollments`;
export const INSTRUCTOR_URL = `${process.env.REACT_APP_API_BASE}/INSTRUCTORSERVICES/api/v1`;
export const COURSES_URL = `${process.env.REACT_APP_API_BASE}/COURSEMANAGEMENTSERVICE/api/v1`;
export const PAYMENTS_URL = `${process.env.REACT_APP_API_BASE}/COURSEMANAGEMENTSERVICE/api/v1/payments`;
export const CERTIFICATE_URL = `${process.env.REACT_APP_API_BASE}/COURSEMANAGEMENTSERVICE/api`;
export const JOBS_PORTAL_URL =`${process.env.REACT_APP_API_BASE}/JOBPORTALMICROSERVICE`;
    
 
const register = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/register`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export { register };



const loginWithUserName = async (data) => {
  try {
    const response = await axios.post(`${BASE_URL}/loginWithUserName`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export { loginWithUserName };

const forgetPassword = async (email) => {
  try {
    const response = await axios.post(`${BASE_URL}/forgot-password`, null, { params: { email } })
    return response;
  } catch (error) {
    throw error;
  }
}

export { forgetPassword };

const resetPassword = async (token,newPassword) => {
  try{
    const response = await axios.post(`${BASE_URL}/reset-password`,null,{params:{token,newPassword}});
    return response;
  }catch(error){
    throw error;
  }
}

export {resetPassword};
 
const profile = async (email) => {

  try{
    const response = await axios.get(`${BASE_URL}/profile`,email, {
      headers: {  
        Authorization: `Bearer ${localStorage.getItem('token')}`
    }});
    return response;
  } catch(error){
    throw error;
  }
};


export { profile };

const profileUpdate = async (formData) => {
  try {
    console.log('Form data:', formData);

    const response = await fetch(`${BASE_URL}/profileUpdate`, {
      method: 'PUT',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json',  
      },
      body: JSON.stringify(formData),
    });

 
    if (!response.ok) {
      const errorData = await response.json();
      console.error('Error response:', errorData);
      throw new Error(errorData.message || 'Failed to update profile');
    }

    const data = await response.json();
     return data;
  } catch (error) {
    console.error('Error updating profile:', error.message);
    throw error;
  }
};

export { profileUpdate };
